import { Metadata } from "next";
import { type ClassValue, clsx } from "clsx";
import { twMerge } from "tailwind-merge";

export function cn(...inputs: ClassValue[]) {
  return twMerge(clsx(inputs));
}

export function generateAvatarFallback(string: string) {
  const names = string.split(" ").filter((name: string) => name);
  const mapped = names.map((name: string) => name.charAt(0).toUpperCase());

  return mapped.join("");
}

export function generateMeta({
  title,
  description,
  canonical
}: {
  title: string;
  description: string;
  canonical: string;
}): Metadata {
  return {
    title: `${title} - Shadcn UI Kit`,
    description: description,
    metadataBase: new URL(`https://shadcnuikit.com`),
    alternates: {
      canonical: `/dashboard${canonical}`
    },
    openGraph: {
      images: [`/images/seo.jpg`]
    }
  };
}

// a function to get the first letter of the first and last name of names
export const getInitials = (fullName: string) => {
  const nameParts = fullName.split(" ");
  const firstNameInitial = nameParts[0].charAt(0).toUpperCase();
  const lastNameInitial = nameParts[1].charAt(0).toUpperCase();
  return `${firstNameInitial}${lastNameInitial}`;
};

/**
 * Today as `yyyy-mm-dd` in the browser's LOCAL day.
 *
 * Deliberately not `toISOString().slice(0, 10)`: that is UTC, so after ~05:30
 * IST it is still yesterday's date, and west of Greenwich it is tomorrow's.
 * Used as `max` on date-of-birth fields, where being a day out is invisible
 * until it reaches a record.
 */
export function todayISO(): string {
  return localISODate(new Date());
}

/** "YYYY-MM-DD" of `d`'s LOCAL calendar day. Never `d.toISOString().slice(0, 10)`:
 *  that is UTC, so in India (UTC+5:30) local midnight–05:30 comes out as the day before. */
export function localISODate(d: Date): string {
  return [
    d.getFullYear(),
    String(d.getMonth() + 1).padStart(2, "0"),
    String(d.getDate()).padStart(2, "0")
  ].join("-");
}
